import {Form} from 'antd'
import React, {useContext} from 'react'
import {getAssistants} from '../../../../services/assistant'
import {InputSearch} from '../../../input-search'
import UserContext from "../../../../context/users";


export default function TransferAssistant({fieldName}) {
  const [user] = useContext(UserContext);

  return (
    <>
      <Form.Item
        label={'Assistente'}
        rules={[{
          required: true,
          message: "É obrigatório escolher um assistente.",
        }]}
        help={"Esse gatilho transfere o atendimento para outro assistente"}
        validateTrigger={['onChange', 'onBlur']}
        name={[fieldName, 'action', 'data', 'assistantID']}>
        <InputSearch
          getCallback={(filters) => getAssistants({companyID: user.companyID, ...filters})}
          placeholder="Escolha um assistente"
        />
      </Form.Item>
    </>
  )
}
